// extracted by mini-css-extract-plugin
module.exports = {"servicePage":"BuildingManagement_servicePage__2dpAK","tailoredService":"BuildingManagement_tailoredService__MVj_u"};